var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequisitions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49995 15H3.45698C2.48433 15 1.88667 13.9414 2.38667 13.1055L4.45308 9.66016C4.79292 9.09376 5.40229 8.75001 6.06245 8.75001H9.77339C12.746 3.71485 17.1796 3.46094 20.1445 3.89454C20.6445 3.96876 21.0351 4.35938 21.1054 4.85548C21.539 7.82032 21.2851 12.2539 16.25 15.2266V18.9375C16.25 19.5977 15.9062 20.207 15.3398 20.5469L11.8945 22.6133C11.0625 23.1133 9.99995 22.5117 9.99995 21.543V17.5C9.99995 16.1211 8.87886 15 7.49995 15ZM18.125 8.75001C18.125 7.71485 17.2851 6.87501 16.25 6.87501C15.2148 6.87501 14.375 7.71485 14.375 8.75001C14.375 9.78516 15.2148 10.625 16.25 10.625C17.2851 10.625 18.125 9.78516 18.125 8.75001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequisitions);
export default __webpack_public_path__ + "static/media/requisitions.b8516901973154abc9879a0f61c563a1.svg";
export { ForwardRef as ReactComponent };